@if(true){
  <div class="horizontal-sidebar p-y-8">
    <div class="container nav-scroll-host">

      <!-- ── Left scroll button ──────────────────────────────────────── -->
      @if(canScrollLeft){
        <button class="nav-scroll-btn scroll-prev" (click)="scrollNav(-220)" aria-label="Scroll left">
          <mat-icon>{{ isRTL ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        </button>
        <div class="nav-fade nav-fade-start"></div>
      }

      <!-- ── Scrollable nav strip ────────────────────────────────────── -->
      <div #navScroll class="nav-scroll-inner" (scroll)="onNavScroll()">
        <div class="horizontal-navbar hstack align-items-center">
          @if(searchText && filteredItems.length === 0){
            <span class="nav-no-result">
              <mat-icon>search_off</mat-icon>
              {{ 'Shared.NoMatchFound' | translate }}
            </span>
          }
          @for(item of filteredItems; track item){
            <app-horizontal-nav-item [item]="item" class="parentBox {{ item.iconName }}" [ngClass]="{
              pactive: item.route === parentActive
            }">
            </app-horizontal-nav-item>
          }
        </div>
      </div>

      <!-- ── Right scroll button ─────────────────────────────────────── -->
      @if(canScrollRight){
        <div class="nav-fade nav-fade-end"></div>
        <button class="nav-scroll-btn scroll-next" (click)="scrollNav(220)" aria-label="Scroll right">
          <mat-icon>{{ isRTL ? 'chevron_left' : 'chevron_right' }}</mat-icon>
        </button>
      }

      <!-- ── Menu search ─────────────────────────────────────────────── -->
      <div class="nav-search" [class.open]="searchOpen">
        <button type="button"
                class="nav-search-btn"
                (click)="toggleSearch()"
                [attr.aria-label]="'Shared.Search' | translate">
          <mat-icon>{{ searchOpen ? 'close' : 'search' }}</mat-icon>
        </button>

        <input #searchInput
               type="text"
               class="nav-search-input"
               [(ngModel)]="searchText"
               (ngModelChange)="onSearchChange($event)"
               (keydown.escape)="closeSearch()"
               [attr.tabindex]="searchOpen ? 0 : -1"
               placeholder="{{ 'Shared.Filter' | translate }}" />
      </div>

    </div>
  </div>
}
